import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const Frame = ({ align, caption, children }) => {
    return (_jsxs("figure", { "data-align": align || 'left', className: "frame", children: [children, caption && _jsx("figcaption", { className: "caption", children: caption })] }));
};
